import { DropdownModel } from "./../../report/models/report-filter-cost-center.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import {
  PersonProfileModel,
  EmailAddressModel,
  PersonProfileAddressModel
} from "../models/personprofile.model";
import { PersonProfileService } from "../models/personprofile.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { TermsConditionPopup } from "../../termsconditionpopup/models/terms-condition-popup.service";
import { PrivacyStatementPopup } from "../../privacypopup/models/privacy-popup.service";
import { TermsConditionStatus } from "../../termsandcondition/models/terms-condition.model";



declare var ChangeBranding: any;

@Component({
  selector: "wego-perosn",
  template: require('../views/personperofile.component.html'),
  providers: [PersonProfileService, TermsConditionPopup, PrivacyStatementPopup],
  styles: [
    `
      .main-header {
        margin-top: 0px !important;
      }
      .input-group.telephone-group .input-group-addon {
        padding: 0px;
        border: 0px;
      }
      .country-select {
        width: 60px;
        border: 1px solid #d2d6de;
        padding: 3px;
      }
    `
  ]
})
export class PersonProfile implements OnInit, OnDestroy {
  public allTNCList: TermsConditionStatus[] = [];
  termsAndConditionHashId: any;
  privacyHashId: any;

  isBodyContent: boolean;
  isPrivacyBodyContent: boolean;

  bodyHTMLText: any;
  privacyBodyHTMLText: string;

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  personHashId: string;
  sub: any;
  apiResponse: IAPIResponse;
  submitted = false;
  model: PersonProfileModel;  
  instanceList: any;
  errorModel: IKeyValueInterface[];
  message: string;
  errorMessage: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlPersonList: string;
  public selectedInstance: string = "";
  flatPickrConfigDateOfBirth: FlatPickrModel;
  isDateOfBirth: boolean = false;
  isLoading: boolean = false;
  countryList: DropdownModel[];
  personCountryList: DropdownModel[];

  @ViewChild("childModal") public childModal: any;
  @ViewChild("termsConditionModel") public termsConditionModel: any;
  @ViewChild("privayStatementModel") public privacyModel: any;


  constructor(
    private personService: PersonProfileService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private termsConditionPopup: TermsConditionPopup
  ) { }

  ngOnInit() {
    // this.translate.setDetectedLang();
    this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
    this.model = new PersonProfileModel();
    this.GetTelephoneCountry();
    this.sub = this.activeRoute.params.subscribe(params => {
      this.isEditMode = false;
      this.personHashId = params["activationCode"] || "";
      if (this.personHashId != "") {
        this.isLoading = true;
        this.isEditMode = true;
        this.personService
          .GetPersonByActivationCode(this.personHashId)
          .subscribe(
            res => {
              if (!res.data) {
                this.router.navigate(["/Linkexpired"]);
                this.isDateOfBirth =
                  this.model.dateOfBirth != "" ? true : false;
              }
              this.model = res.data;
              localStorage.setItem("language", this.model.instanceLanguage);
              this.translate.setDetectedLang();
              if (this.model.liceanceNumberValidated) {
                this.flatPickrConfigDateOfBirth.clickOpens = false;
              }
              ChangeBranding(res.data.personMasterHashId, "ADMIN");
              this.isLoading = false;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.message = <any>error;
              this.isLoading = false;
            }
          );
      }
    });
    this.GetTermsConditionByPersonActivationCode(this.personHashId);
    this.GetPrivacyByPersonActivationCode(this.personHashId);

    this.GetPersonCountry();
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = false;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.maxDate = new Date();
    return flatPickrConfig;
  }
  onSubmit(forms: any) {
    this.submitted = true;
    this.UpdatePersonProfile();
  }

  public GetPersonCountry() {
    this.authService.GetPersonCountry()
      .subscribe(
        res => {
          this.personCountryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public UpdatePersonProfile() {
    this.model.termsAndConditionsHashId = this.termsAndConditionHashId;
    this.model.privacyHashId = this.privacyHashId;
    this.model.allTermsConditionsList = this.allTNCList;

    this.personService.UpdatePersonProfile(this.model).subscribe(
      res => {
        if (res.data) {
          window.location.href= WeGoConfig.CONFIRMED_URL;
        } else {
          this.errorModel = res.error;
          // this.router.navigate(['personprofile/alreadyActive']);
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry().subscribe(
      res => {
        this.countryList = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetTermsConditionByPersonActivationCode(personActivationCode: string) {
    this.termsConditionPopup
      .GetTermsAndConditionsByPersonActivationCode(personActivationCode)
      .subscribe(
        res => {
          if (res.data) {
            this.allTNCList = res.data;
            //   this.bodyHTMLText = res.data.content;
            //   if (res.data.content) {
            //     this.isBodyContent = true;
            //   }
            //   this.termsAndConditionHashId = res.data.termsAndConditionsHashId;
            // } else {
            //   this.errorMessage = res.error;
            // }
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetPrivacyByPersonActivationCode(personActivationCode: string) {
    this.termsConditionPopup
      .GetPrivacyByPersonActivationCode(personActivationCode)
      .subscribe(
        res => {
          if (res.data && res.data.content) {
            this.privacyBodyHTMLText = res.data.content;
            if (res.data.content) {
              this.isPrivacyBodyContent = true;
            }
            this.privacyHashId = res.data.termsAndConditionsHashId;
          } else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public showTnC(bodyHTMLText: string) {
    this.termsConditionModel.show(bodyHTMLText);
  }

  public showPrivacyStatement() {
    this.privacyModel.show(this.privacyBodyHTMLText);
  }

  ngOnDestroy() {
    ChangeBranding();
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/personprofile/componets/personprofile.componets.ts